import { getWindowLocation } from 'utils/window';

export const setWindowLocation = (newLocation: string) => {
  getWindowLocation().href = newLocation;
};
